module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/modal/modal-mensaje-confirmacion/modal-mensaje-confirmacion.component.css
// module id = ./src/app/shared/modal/modal-mensaje-confirmacion/modal-mensaje-confirmacion.component.css
// module chunks = main